import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import moment from 'moment'

import QUIZ_SCORING from '../config/quizScoring'
import QUIZ_STATE from '../enums/quizState'

dayjs.extend(duration)

const getAttemptState = scorePercentage => {
    let quizState
    if (scorePercentage !== undefined) {
        const sortedScores = Object.keys(QUIZ_SCORING).sort((a, b) =>
            parseInt(a) - parseInt(b) < 0 ? 1 : -1
        )

        for (let index = 0; index < sortedScores.length; index++) {
            const element = sortedScores[index]
            if (scorePercentage - parseInt(element) >= 0) {
                quizState = QUIZ_SCORING[element].state
                break
            }
        }
    } else {
        quizState = QUIZ_STATE.NOT_PASSED
    }

    return quizState
}

const calcRetakeRemTime = latestAttemptStartTime => {
    const retakeInterval = parseInt(
        import.meta.env.VITE_PROGRESS_QUIZ_RETAKE_INTERVAL
    )

    const nextAttemptTime = moment(latestAttemptStartTime).add(
        retakeInterval,
        'minutes'
    )

    return nextAttemptTime.diff(moment().utcOffset('+0530')) > 0
        ? nextAttemptTime.diff(moment().utcOffset('+0530'))
        : -1
}

const formatDuration = durationInMinutes => {
    if (!durationInMinutes) return '--:--'

    const attemptDuration = dayjs.duration(durationInMinutes, 'minutes')
    let duration

    if (durationInMinutes < 60) {
        duration = `${attemptDuration.get('minutes')}m`
    } else {
        if (durationInMinutes % 60 === 0) {
            duration = `${Math.floor(durationInMinutes / 60)}h`
        } else {
            duration = `${Math.floor(
                durationInMinutes / 60
            )}h ${attemptDuration.get('minutes')}m`
        }
    }

    return duration
}

const renderRemTime = durationInSeconds => {
    // If remaining time is less than 5 minutes.
    if (durationInSeconds < 300) {
        return dayjs.duration(durationInSeconds * 1000).format('m[m] s[s]')
    } else if (durationInSeconds >= 300 && durationInSeconds < 3600) {
        // If remaining time is between 5 minutes and 59 minutes.
        return dayjs.duration(durationInSeconds * 1000).format('m[m]')
    } else {
        // If remaining time is above or equal to 1 hour.
        const attemptDuration = dayjs.duration(durationInSeconds * 1000)
        return `${Math.floor(durationInSeconds / 3600)}h ${attemptDuration.get(
            'minutes'
        )}m`
    }
}

export { calcRetakeRemTime, formatDuration, getAttemptState, renderRemTime }
